import React from 'react'
import { ESGVerificationStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Input,
} from '../../components'
import { isEmpty } from 'lodash'
import { ICONS } from '../../themes'
import { ROUTE_PATH, redirect, STRING } from '../../helpers'
import { buyermangeController } from '../../apiService'
import moment from 'moment'

export class ESGVerificationContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      options: [
        { value: '0', label: 'All' },
        { value: '1', label: 'Active' },
        { value: '2', label: 'Inactive' },
      ],
      isSortBy: [{ name: 'tax_id', value: undefined }],
      search: '',
    }
  }

  toggleSort = evt => {
    var value
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        value = 'asc'
      } else if (column.name === evt && column.value == 'asc') {
        value = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        value = 'asc'
      }
      return value
    })
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => columns.name === evt)
      .map(column => column.value)[0]
  }

  render() {
    const { options, search } = this.state
    return (
      <React.Fragment>
        <ESGVerificationStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_esg_verification"
                  src={ICONS['icon-esg.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  {STRING.ESG_VERIFICATION}
                </Section>

                <Section
                  id="page_breadcrumb_buyer_management"
                  className="breadcrumbs"
                >
                  <Button
                    className="breadcrumb"
                    onClick={() => {
                      this.props.history.push(ROUTE_PATH.HOME.LINK)
                    }}
                  >
                    <span>{STRING.HOME}</span>
                  </Button>

                  <Button className="breadcrumb current">
                    <span>{STRING.ESG_VERIFICATION}</span>
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  id="filter_search_input"
                  placeholder="Tax ID, Company Name"
                  onKeyDown={e => {
                    this._searchTagAdd(e)
                  }}
                  onChange={e => {
                    this._searchTagAdd(e)
                  }}
                />

                <SelectBox
                  onChange={e => {
                    this.optionsValue = e.value
                    this._fetchBuyerList(e.value, search, 1)
                  }}
                  id="active_status_filter"
                  className="table-filter"
                  options={options}
                  placeholder="All"
                  isSearchable={false}
                  isClearable={false}
                />
              </Section>

              <Section className="table-wrapper">
                <Table className="buyer split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR className="header">
                      <Table.TH
                        className="tax-id"
                        id="tax_id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('tax_id')}
                        onClick={() => this.toggleSort('tax_id')}
                      >
                        TAX ID
                      </Table.TH>

                      <Table.TH className="supplier" id="supplier_header">
                        SUPPLIER
                      </Table.TH>

                      <Table.TH
                        className="business-type"
                        id="business_type_header"
                      >
                        BUSINESS TYPE
                      </Table.TH>

                      <Table.TH className="email" id="email_header">
                        EMAIL
                      </Table.TH>

                      <Table.TH className="phone" id="phone_header">
                        PHONE
                      </Table.TH>

                      <Table.TH className="status" id="status_header">
                        STATUS
                      </Table.TH>

                      <Table.TH className="last-update" id="last_update_header">
                        LAST UPDATE
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        ACTIONS
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    <Table.TR>
                      <Table.TD className="tax-id"></Table.TD>

                      <Table.TD className="supplier"></Table.TD>

                      <Table.TD className="business-type"></Table.TD>

                      <Table.TD className="email"></Table.TD>

                      <Table.TD className="phone">0123456789-58</Table.TD>

                      <Table.TD className="status">
                        <p className="completed-status">Completed</p>
                      </Table.TD>

                      <Table.TD className="last-update"></Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button
                            className="link"
                            onClick={() => {
                              this.props.history.push(
                                '/buyer-edit-form:' /*+ e.id*/
                              )
                            }}
                          >
                            <Image
                              className="edit-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>

                    <Table.TR>
                      <Table.TD className="tax-id"></Table.TD>

                      <Table.TD className="supplier"></Table.TD>

                      <Table.TD className="business-type"></Table.TD>

                      <Table.TD className="email"></Table.TD>

                      <Table.TD className="phone"></Table.TD>

                      <Table.TD className="status">
                        <p className="pending-status">Pending</p>
                      </Table.TD>

                      <Table.TD className="last-update"></Table.TD>

                      <Table.TD className="actions">
                        <Section>
                          <Button
                            className="link"
                            onClick={() => {
                              this.props.history.push(
                                '/buyer-edit-form:' /*+ e.id*/
                              )
                            }}
                          >
                            <Image
                              className="edit-icon"
                              src={ICONS['icon-edit.svg']}
                              alt="edit"
                            />
                          </Button>
                        </Section>
                      </Table.TD>
                    </Table.TR>
                  </Table.TBODY>
                  {/* {isEmpty(listBuyer) && (
                    <Section className="no-result-found">
                      <Image
                        src={ICONS['icon-ssr.png']}
                        className="no-result"
                      />
                      <p>No result found</p>
                    </Section>
                  )} */}
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              <Section className="showing-item">
                Showing 1 to 10 of 60 entries
              </Section>

              <Section className="paginate-wrapper">
                <Paginate
                  activePage={1}
                  itemsCountPerPage={10}
                  totalItemsCount={450}
                  pageRangeDisplayed={5}
                  // onChange={() => ({})}
                />

                <Section className="moveto-wrapper">
                  <Input
                    className="paginate-moveto"
                    label="Page"
                    defaultValue="1"
                    isHorizontal
                    maxLength="4"
                  />

                  <Button>go</Button>
                </Section>
              </Section>
            </Section>
          </Section>
        </ESGVerificationStyled>
      </React.Fragment>
    )
  }
}
